<!--
 * @Author: ocean
 * @Description: 数据统计 充电数据统计 商户统计列表
-->
<template>
  <scroll-layout class="merchantStatistics-list">
    <template slot="header">
      <ykc-warm-tip
        type="warning"
        v-if="topTipStatus"
        :description="topTip"
        @click="topTipStatus = false"></ykc-warm-tip>
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParam"
        @clean="handleSearchClean"
        @click="handleSearchConfirm"></ykc-search>
    </template>
    <div class="wrap-box">
      <div class="tags" v-show="switchOver">
        报表统计口径说明
        <span @click="tagClick()">?</span>
      </div>
      <div v-if="!switchOver">
        <div class="but-box">
          <!-- <ykc-button type="plain" @click="switchOverFn(1)">报表模式</ykc-button> -->
        </div>
        <statistics-chart
          ref="statisticsChart"
          :page="'platform'"
          :title="'充电趋势'"
          :isUpdate="isUpdate"
          :searchParams="searchParam"
          :chargingTrendKey="'queryStationChargingTrendList'"></statistics-chart>
      </div>
      <div v-if="switchOver">
        <ykc-table
          ref="YkcTable"
          operateFixedType="right"
          :data="tableData"
          :title="tableTitle"
          :columns="tableColumns"
          :operateButtons="tableOperateButtons">
          <template #headerButtons>
            <div class="table-header-button">
              <ykc-button v-rbac="'data:charge:merchant:export'" type="plain" @click="doExportFile">
                导出
              </ykc-button>
              <!-- <ykc-button type="plain" @click="switchOverFn(2)">图表模式</ykc-button> -->
            </div>
          </template>
          <ykc-pagination
            align="right"
            slot="pagination"
            ref="YkcPagination"
            :total="pageInfo.total"
            :page-size.sync="pageInfo.size"
            :current-page.sync="pageInfo.current"
            @current-change="handlePaginationCurrentChange"
            @size-change="handlePaginationSizeChange"></ykc-pagination>
        </ykc-table>
        <ykc-operation-dialog
          size="large"
          title="统计口径说明"
          confirm-btn-txt="同意"
          :show-footer="false"
          :show.sync="operationStatus">
          <div slot="content">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              :autosize="{ minRows: 2 }"
              v-model="textarea2"></el-input>
          </div>
        </ykc-operation-dialog>
      </div>
    </div>
    <div class="bottomBtn" @click="switchOverFn">
      <div><i :class="switchOver ? 'el-icon-s-data' : 'el-icon-s-grid'"></i></div>
      <div>{{ switchOver ? '图表模式' : '列表模式' }}</div>
    </div>
  </scroll-layout>
</template>
<script>
  import { getLastTime, offlineExport } from '@/utils';
  import { operatorData, dataStatisticsServe } from '@/service/apis';

  import statisticsChart from '../../components/dataStatisticsChart.vue';

  export default {
    name: 'merchantStatisticsList',
    components: {
      statisticsChart,
    },
    data() {
      return {
        switchOver: true,
        topTip:
          '温馨提示：由于统计数据量过大，默认显示当日统计数据，需要查看其他数据请使用查询功能。',
        tradeNo: null,
        isUpdate: false,
        topTipStatus: true,
        operationStatus: false,
        userOperatorList: [], // 归属商户组件使用数据源
        searchParam: {
          date: {},
          startTime: '',
          endTime: '',
          dateType: '1',
          stationOperatorList: [],
        },
        tableTitle: '明细列表', // 列表表格
        tableData: [],
        tableOperateButtons: [], // 列表操作
        tableColumns: [
          {
            label: '归属商户',
            prop: 'stationOperatorName',
            fixed: true,
            width: '200px',
            scopedSlots: {
              default: ({ row }) => {
                return (
                  <span
                    style="color:blue; cursor: pointer;"
                    onClick={() => this.handleRowClick(row)}>
                    {row.stationOperatorName}
                  </span>
                );
              },
            },
          },
          { label: '电量(度)', prop: 'chargedPower', width: '200px' },
          { label: '充电时长(h)', prop: 'chargedTime', minWidth: '150px' },
          { label: '充电次数', prop: 'chargedCount', minWidth: '150px' },
          { label: '电费(元)', prop: 'chargedAmount', minWidth: '150px' },
          { label: '服务费(元)', prop: 'serviceAmount', minWidth: '150px' },
          { label: '订单总金额(元)', prop: 'totalAmount', minWidth: '160px' },
          {
            label: '用户实付合计(元)',
            prop: 'chargedAmountAfterDiscount',
            minWidth: '150px',
          },
          {
            label: '引流抽成费用(元)',
            prop: 'commissionAmount',
            minWidth: '150px',
          },
          {
            label: '商户实收合计(元)',
            prop: 'operatorActualIncome',
            minWidth: '150px',
          },
        ],
        pageInfo: {
          current: 1,
          size: 10,
        },
        textarea2: `电量(度)：所有历史订单电量汇总
充电时长(h)：所有历史订单充电时长汇总
充电次数：订单总数量
电费(元)：所有历史订单原价电费
服务费(元)：所有历史订单原价服务费
订单总金额(元)：所有历史订单原价总金额
用户实付合计(元)：订单总金额- 平台卡券优惠- 平台活动优惠-商户卡券优惠-商户活动优惠-会员折扣优惠
引流抽成费用(元)：所有历史订单引流抽成总金额
商户实收合计(元)：订单总金额-商户卡券优惠-商户活动优惠-引流抽成费用`,
      };
    },
    created() {
      const startDate = getLastTime('yyyy-MM-dd', 7);
      const endDate = getLastTime('yyyy-MM-dd', 1);

      this.searchParam.date = [startDate, endDate];
      this.searchParam.startTime = startDate;
      this.searchParam.endTime = endDate;

      this.requestUserOperatorList();
      this.requestList();
    },
    computed: {
      searchData() {
        return [
          {
            key: 'date',
            isDateType: false,
            label: '时间维度',
            comName: 'YkcDatePicker',
          },
          {
            multiple: true,
            label: '商户名称',
            comName: 'YkcDropdown',
            key: 'stationOperatorList',
            placeholder: '请选择商户名称',
            data: this.userOperatorList,
            // configSet: {
            //   label: 'name',
            //   value: 'operatorId',
            // },
          },
        ];
      },
    },
    methods: {
      /**
       * 获取归属商户数据
       */
      requestUserOperatorList() {
        operatorData
          .userOperatorList({})
          .then(res => {
            console.log('获取归属商户数据+++++', res);
            res.map(item => {
              return this.userOperatorList.push({
                id: item.operatorId,
                name: item.name,
              });
            });
          })
          .catch(err => {
            console.log(err);
          });
      },
      /**
       * 请求列表数据
       */
      requestList() {
        const pageInfos = (({ current, size }) => ({ current, size }))(this.pageInfo);
        const searchParams = (({ startTime, endTime, dateType, stationOperatorList }) => ({
          startTime,
          endTime,
          dateType,
          stationOperatorList,
        }))(this.searchParam);
        const reqParams = {
          ...pageInfos,
          ...searchParams,
        };
        dataStatisticsServe
          .queryOperatorChargingList(reqParams)
          .then(res => {
            this.isUpdate = false;
            this.tableData = res.records || [];
            this.pageInfo.total = res.total || 0;
          })
          .catch(err => {
            console.log(err);
          });
      },
      /**
       * 跳转商户
       */
      handleRowClick(row) {
        let type = '';

        if (row.operatorType === '1') {
          type = 'platForm';
        } else if (row.operatorType === '2') {
          type = 'union';
        }

        this.$router.push({
          path: '/merchantCenter/merchantPlatform/Detail',
          query: { type, id: row.operatorId },
        });
      },
      /**
       * 统计说明
       */
      tagClick() {
        this.operationStatus = true;
      },
      /**
       * 导出
       */
      doExportFile() {
        offlineExport({
          downloadType: 'platform_operator_charging_trend',
          jsonNode: {
            ...this.searchParam,
          },
        });
      },
      /**
       * 点击筛选查询按钮
       * */
      handleSearchConfirm(searchData) {
        console.log('searchData++++', searchData);
        this.pageInfo.current = 1;
        const searchFormData = { ...searchData };

        if (searchData.date && Array.isArray(searchData.date) && searchData.date.length > 0) {
          const [startDate, endDate] = searchData.date;
          searchFormData.startTime = startDate;
          searchFormData.endTime = endDate;
        }

        this.searchParam = searchFormData;
        this.isUpdate = true;
        this.requestList();
      },
      /**
       * 点击清空查询按钮
       * */
      handleSearchClean(form) {
        Object.assign(this.searchParam, form);
        // 切换成日，默认状态
        const startDate = getLastTime('yyyy-MM-dd', 7);
        const endDate = getLastTime('yyyy-MM-dd', 1);

        this.searchParam.date = [startDate, endDate];
        this.searchParam.startTime = startDate;
        this.searchParam.endTime = endDate;
        this.searchParam.dateType = '1';
        console.log('清空查询', form);
      },
      /**
       * 分页器页数
       * */
      handlePaginationCurrentChange(current) {
        this.pageInfo.current = current;
        this.requestList();
      },
      /**
       * 分页器条数
       * */
      handlePaginationSizeChange(size) {
        this.pageInfo.current = 1;
        this.pageInfo.size = size;
        this.requestList();
      },
      /**
       * 切换到报表或图表模式
       */
      switchOverFn() {
        this.switchOver = !this.switchOver;
        console.log(this.switchOver);
        if (this.switchOver) {
          this.requestList();
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .ykc-checkbox .icon-check {
    top: 7px;
  }

  .but-box {
    display: flex;
    justify-content: flex-end;
  }
  .merchantStatistics-list {
    .wrap-box {
      position: relative;
      .tags {
        display: flex;
        align-items: center;
        font-size: 12px;
        position: absolute;
        top: 20px;
        left: 85px;
        > span {
          display: block;
          width: 16px;
          height: 16px;
          margin-left: 8px;
          font-size: 10px;
          line-height: 16px;
          color: #fff;
          text-align: center;
          cursor: pointer;
          border-radius: 50%;
          background: blue;
        }
      }
      .ykc-table {
        .el-table .el-table__row {
          .cell .userStatus {
            padding-left: 8px;
            position: relative;
          }

          .cell .userStatus::after {
            display: block;
            content: '';
            width: 5px;
            height: 5px;
            border-radius: 100%;
            background: #d0021b;
            position: absolute;
            top: 5.5px;
            left: 0;
          }

          .cell .status-blue::after {
            background: #4d8cfd;
          }

          .cell .status-green::after {
            background: #02c498;
          }

          .cell .status-black::after {
            background: #9b9b9b;
          }
        }

        .sealBtn {
          color: #4d8cfd;
          cursor: pointer;
        }
      }
    }
    .bottomBtn {
      position: absolute;
      right: 10px;
      bottom: 20px;
      width: 90px;
      height: 45px;
      border-radius: 10px;
      color: #409eff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
      background-color: #fff;
      padding-right: 5px;
      cursor: pointer;
      z-index: 1000;

      i {
        margin: 0 5px;
      }
      &:hover {
        background-color: #f2f6fc;
      }
    }
  }
</style>
